<div #captcha></div>
<div *ngIf="!captcha_initialised && timeout">
	<p><i>reCAPTCHA doesn't seem to be working. Is it being blocked by your browser? If so, please unblock www.google.com and www.gstatic.com and refresh this page.</i></p>
</div>